var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 12L7 16V13H16V11H7V8L2 12Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0007 2.99805C10.5957 2.99805 8.33572 3.93505 6.63672 5.63505L8.05072 7.04905C9.37272 5.72705 11.1307 4.99805 13.0007 4.99805C14.8707 4.99805 16.6287 5.72705 17.9507 7.04905C19.2727 8.37105 20.0017 10.129 20.0017 11.999C20.0017 13.869 19.2727 15.627 17.9507 16.949C16.6287 18.271 14.8707 19 13.0007 19C11.1307 19 9.37272 18.271 8.05072 16.949L6.63672 18.363C8.33572 20.063 10.5957 21 13.0007 21C15.4057 21 17.6657 20.063 19.3647 18.363C21.0647 16.664 22.0017 14.404 22.0017 11.999C22.0017 9.59405 21.0647 7.33405 19.3647 5.63505C17.6657 3.93505 15.4057 2.99805 13.0007 2.99805Z",
  fill: "black"
});

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5153fcce3a00e972a01e15558b8429fa.svg";
export { ForwardRef as ReactComponent };